
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surf",
      function () {
        return require("private-next-pages/surf.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surf"])
      });
    }
  